import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const MessageSystem = ({ message, updateAt }) => (
  <>
    <div className="w-3/5 mx-auto border border-gray-400 rounded-lg my-3 px-2 py-1 text-center">
      {message.content &&
        message.content.split('.').map((content, index) => (
          <Fragment key={index}>
            <p className="text-xs py-1 text-gray-600 font-medium">{content}</p>
          </Fragment>
        ))}
    </div>
    <div className="flex w-full justify-center">
      <div className="mb-3 mt-1 text-xs text-gray-500">
        <span>{updateAt}</span>
      </div>
    </div>
  </>
)

MessageSystem.propTypes = {
  message: PropTypes.object,
  updateAt: PropTypes.string,
}

export default MessageSystem
